import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import moment from 'moment';
import { Card, Image } from 'semantic-ui-react';
import SkeletonCard from 'components/common/Skeletons/Card';
import { capitalizeEachWords } from 'utils/capitalize';
import useWalletCard from '../useWalletCard';
import WalletDetailsModal from '../WalletDetailsModal';
import './index.scss';

const WalletCard = ({
  label,
  balance,
  data,
  logo,
  loading,
  organizationName,
}) => {
  const { isModalVisible, openModal, closeModal } = useWalletCard();

  if (loading) {
    return (
      <Card className="wallet-card">
        <SkeletonCard variant="wallet" />
      </Card>
    );
  }

  return (
    <>
      <Card className="wallet-card">
        <div className="wallet-card__left">
          <div className="wallet-card__left__header">
            <div className="wallet-card__left__header__logo">
              <Image src={logo} alt={label} />
            </div>
            <h3>{capitalizeEachWords(label)}</h3>
          </div>
          <p className="wallet-card__left__balance">
            {numeral(balance).format('0.0a')}
          </p>
          <p className="wallet-card__left__date">
            {moment().format('Do MMMM YYYY')}
          </p>
        </div>
        <div className="wallet-card__right">
          <div
            tabIndex="-1"
            role="button"
            onKeyDown={() => null}
            className="wallet-card__right__more"
            onClick={openModal}
          >
            View more
          </div>
          {/* // TODO: this needs massive backend changes */}
          {/* <div className="wallet-card__right__last-period">
            <div className="wallet-card__right__last-period__icon" />
            <span>5% vs last period</span>
          </div> */}
        </div>
      </Card>

      <WalletDetailsModal
        isOpen={isModalVisible}
        onClose={closeModal}
        label={capitalizeEachWords(label)}
        data={data}
        balance={balance}
        organizationName={organizationName}
      />
    </>
  );
};

export default WalletCard;

WalletCard.propTypes = {
  label: PropTypes.string.isRequired,
  balance: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  logo: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
  organizationName: PropTypes.string.isRequired,
};
